/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchJobLogExtra
 */
export interface BatchJobLogExtra {
    [key: string]: any | any;
    /**
     * 
     * @type {string}
     * @memberof BatchJobLogExtra
     */
    model?: BatchJobLogExtraModelEnum;
    /**
     * Additional un-structured meta-data about the job. This may include (but is not limited to): validation errors, model processing metrics (count, durations, etc), failure reasons or any other arbitrarily nested key-value pairs.
     * @type {{ [key: string]: any; }}
     * @memberof BatchJobLogExtra
     */
    meta?: { [key: string]: any; };
}

/**
* @export
* @enum {string}
*/
export enum BatchJobLogExtraModelEnum {
    Absence = 'Absence',
    AbsenceCategory = 'AbsenceCategory',
    AccessRole = 'AccessRole',
    AccessRolesPermission = 'AccessRolesPermission',
    Address = 'Address',
    BatchJobLog = 'BatchJobLog',
    BatchJobMessage = 'BatchJobMessage',
    BillingCancellation = 'BillingCancellation',
    BillingCouponRedemption = 'BillingCouponRedemption',
    BillingCredit = 'BillingCredit',
    BillingCreditDelta = 'BillingCreditDelta',
    BillingDetail = 'BillingDetail',
    BillingInvoice = 'BillingInvoice',
    BillingInvoiceLine = 'BillingInvoiceLine',
    BillingPackage = 'BillingPackage',
    BillingPackageQuotaOverride = 'BillingPackageQuotaOverride',
    BillingPackagesBillingProductPrice = 'BillingPackagesBillingProductPrice',
    BillingPayment = 'BillingPayment',
    BillingPaymentMethod = 'BillingPaymentMethod',
    BillingProduct = 'BillingProduct',
    BillingProductPrice = 'BillingProductPrice',
    BillingQuotaDefinition = 'BillingQuotaDefinition',
    BillingQuotaOverride = 'BillingQuotaOverride',
    BillingSubscription = 'BillingSubscription',
    BillingSubscriptionsBillingProductPrice = 'BillingSubscriptionsBillingProductPrice',
    BillingWallet = 'BillingWallet',
    BillingWalletType = 'BillingWalletType',
    BudgetSummary = 'BudgetSummary',
    ClockInPortal = 'ClockInPortal',
    ClockInPortalsLocation = 'ClockInPortalsLocation',
    ClockingEvent = 'ClockingEvent',
    ClockingSetting = 'ClockingSetting',
    CompaniesFeatureFlag = 'CompaniesFeatureFlag',
    CompaniesFeatureGroup = 'CompaniesFeatureGroup',
    Company = 'Company',
    CompanyNotificationChannel = 'CompanyNotificationChannel',
    CompanyOnboarding = 'CompanyOnboarding',
    CompanySetting = 'CompanySetting',
    DaySummary = 'DaySummary',
    DigiticketsConnection = 'DigiticketsConnection',
    DigiticketsScheduleMap = 'DigiticketsScheduleMap',
    Document = 'Document',
    DocumentAcceptance = 'DocumentAcceptance',
    DocumentRead = 'DocumentRead',
    DocumentVersion = 'DocumentVersion',
    DocumentVersionsEmployee = 'DocumentVersionsEmployee',
    DocumentsEmployee = 'DocumentsEmployee',
    DocumentsJobRole = 'DocumentsJobRole',
    EmergencyContact = 'EmergencyContact',
    Employee = 'Employee',
    EmployeeAbsenceSummary = 'EmployeeAbsenceSummary',
    EmployeeAttribute = 'EmployeeAttribute',
    EmployeeClockingProfile = 'EmployeeClockingProfile',
    EmployeeGroup = 'EmployeeGroup',
    EmployeeInvite = 'EmployeeInvite',
    EmployeeLeaveBalancesSummary = 'EmployeeLeaveBalancesSummary',
    EmployeeLeaveSummary = 'EmployeeLeaveSummary',
    EmployeeLeaveTypeBalance = 'EmployeeLeaveTypeBalance',
    EmployeeMessage = 'EmployeeMessage',
    EmployeeMessageRecipient = 'EmployeeMessageRecipient',
    EmployeeNotificationChannel = 'EmployeeNotificationChannel',
    EmployeeOnboarding = 'EmployeeOnboarding',
    EmployeePayDetail = 'EmployeePayDetail',
    EmployeePersonalDetail = 'EmployeePersonalDetail',
    EmployeesAccessRole = 'EmployeesAccessRole',
    EmployeesAccessRolesPermission = 'EmployeesAccessRolesPermission',
    EmployeesAccessRolesPermissionsTarget = 'EmployeesAccessRolesPermissionsTarget',
    EmployeesEmployeeAttribute = 'EmployeesEmployeeAttribute',
    EmployeesJobRole = 'EmployeesJobRole',
    EmployeesLocation = 'EmployeesLocation',
    EmployeesSchedule = 'EmployeesSchedule',
    FeaturesEnabled = 'FeaturesEnabled',
    History = 'History',
    HolidayRegion = 'HolidayRegion',
    IcalFeed = 'IcalFeed',
    IcrTouchConnection = 'IcrTouchConnection',
    IcrTouchScheduleConfig = 'IcrTouchScheduleConfig',
    JobRole = 'JobRole',
    LeaveAdjustment = 'LeaveAdjustment',
    LeaveAllowanceChunk = 'LeaveAllowanceChunk',
    LeavePeriod = 'LeavePeriod',
    LeavePoliciesLeaveType = 'LeavePoliciesLeaveType',
    LeavePolicy = 'LeavePolicy',
    LeaveRequest = 'LeaveRequest',
    LeaveSetting = 'LeaveSetting',
    LeaveSettingsDefaultLeaveApprover = 'LeaveSettingsDefaultLeaveApprover',
    LeaveType = 'LeaveType',
    LeaveTypeAccrual = 'LeaveTypeAccrual',
    Location = 'Location',
    MfaDevice = 'MfaDevice',
    NotificationSetting = 'NotificationSetting',
    Offer = 'Offer',
    OffersBehaviour = 'OffersBehaviour',
    OffersQuota = 'OffersQuota',
    OffersRedemption = 'OffersRedemption',
    OffersUsage = 'OffersUsage',
    OpenShiftResponse = 'OpenShiftResponse',
    PayCycle = 'PayCycle',
    PayPeriod = 'PayPeriod',
    PayRule = 'PayRule',
    PayType = 'PayType',
    PendingAction = 'PendingAction',
    PublicHoliday = 'PublicHoliday',
    Schedule = 'Schedule',
    ScheduleEvent = 'ScheduleEvent',
    ScheduleEventsSchedule = 'ScheduleEventsSchedule',
    ScheduleOverviewSummary = 'ScheduleOverviewSummary',
    ScheduleSetting = 'ScheduleSetting',
    ScheduleTemplate = 'ScheduleTemplate',
    ScheduledBreak = 'ScheduledBreak',
    Shift = 'Shift',
    ShiftArea = 'ShiftArea',
    ShiftAreaSession = 'ShiftAreaSession',
    ShiftAreasLocation = 'ShiftAreasLocation',
    ShiftConflict = 'ShiftConflict',
    ShiftCost = 'ShiftCost',
    ShiftSwap = 'ShiftSwap',
    ShiftTemplate = 'ShiftTemplate',
    ShiftTemplateAreaSession = 'ShiftTemplateAreaSession',
    ShiftTemplateBreak = 'ShiftTemplateBreak',
    ShiftTemplatesTag = 'ShiftTemplatesTag',
    ShiftsTag = 'ShiftsTag',
    Tag = 'Tag',
    TimesheetBreak = 'TimesheetBreak',
    TimesheetEntriesTag = 'TimesheetEntriesTag',
    TimesheetEntry = 'TimesheetEntry',
    TimesheetEntryConflict = 'TimesheetEntryConflict',
    TimesheetEntryCost = 'TimesheetEntryCost',
    TimesheetEntryExport = 'TimesheetEntryExport',
    TimesheetEntrySummary = 'TimesheetEntrySummary',
    TimesheetSetting = 'TimesheetSetting',
    TrekksoftClientCredential = 'TrekksoftClientCredential',
    Unavailability = 'Unavailability',
    Upload = 'Upload',
    User = 'User',
    WorkPattern = 'WorkPattern',
    WorkPatternOverride = 'WorkPatternOverride'
}


/**
 * Check if a given object implements the BatchJobLogExtra interface.
 */
export function instanceOfBatchJobLogExtra(value: object): value is BatchJobLogExtra {
    return true;
}

export function BatchJobLogExtraFromJSON(json: any): BatchJobLogExtra {
    return BatchJobLogExtraFromJSONTyped(json, false);
}

export function BatchJobLogExtraFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchJobLogExtra {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'model': json['model'] == null ? undefined : json['model'],
        'meta': json['meta'] == null ? undefined : json['meta'],
    };
}

  export function BatchJobLogExtraToJSON(json: any): BatchJobLogExtra {
      return BatchJobLogExtraToJSONTyped(json, false);
  }

  export function BatchJobLogExtraToJSONTyped(value?: BatchJobLogExtra | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'model': value['model'],
        'meta': value['meta'],
    };
}

